import React from 'react';
import PropTypes from 'prop-types';
import Format from '..';

import './index.css';

const Percentage = ({ amount, className, decimalScale }) => (
  <Format className={`Percentage ${className}`.trim()}>
    {`${(amount * 100).toFixed(decimalScale)}%`}
  </Format>
);

Percentage.propTypes = {
  amount: PropTypes.number.isRequired,
  className: PropTypes.string,
  decimalScale: PropTypes.number,
};

Percentage.defaultProps = {
  className: '',
  decimalScale: 0,
};

export default Percentage;
